import LabeledSelect from './LabeledSelect';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {tryGetAllPredictionCampaign, tryGetAllBannerTypes, tryGetPredictionCampaign, tryGetPredictionCategories} from "../../redux/slices/searchSlice";
import {DangerButton} from "../CustomButton";

const PredictionCategorySelect = ({
                        label,
                        value,
                        campaignId,
                        onChange,
                        placeholder = 'Select Banner type',
                        emptyMsg = 'No data',
                        extData,
                        excludesDefault = false,
                        ...props
                      }) => {
  const dispatch = useDispatch();
  const {loading, data = [], error, init} = useSelector((state) => state.search.predictionCategories);

  useEffect(() => {
    if (!loading && !error && campaignId)
      retry()
  }, [campaignId]);

  useEffect(() => {
    if (extData && data.length) {
      const selected = data.find((d) => d.id === extData);
      if (onChange) {
        onChange(selected);
      }
    }

  }, [extData, data]);

  const retry = () => {
    dispatch(tryGetPredictionCategories(campaignId));
  };


  return (
    error ?
      <div className="flex items-center justify-between border-gray-300 border-solid border px-2 rounded">
        <div className="text-error-100 ">{error}</div>
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div> :
      <LabeledSelect
        placeholder="Select Type"
        loading={loading}
        isDisabled={loading}
        options={data}
        value={value}
        {...props}
        onChange={onChange}
        getOptionLabel={(v) => v.title}
        getOptionValue={(v) => v}
      />
  );
};

export default PredictionCategorySelect;

